import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { useToolCardById } from './stickerCardMapping';
import { ActionStickerCardSection, HomePageSection } from './useGetHomePageSections';

const ATTAIN_FINANCIAL_FREEDOM_STRINGS =
  appStrings.modules.home.sections.personalHealthAndWellness.attainFinancialFreedom;
const BE_WELL_STRINGS = appStrings.modules.home.sections.personalHealthAndWellness.beWell;
const MASTER_MINDSETS_STRINGS =
  appStrings.modules.home.sections.personalHealthAndWellness.masterMindsets;

export const ATTAIN_FINANCIAL_FREEDOM_SECTION = ({
  navigate,
}: HomePageSection): ActionStickerCardSection => {
  const { getStickerCard } = useToolCardById({ navigate });

  return {
    title: ATTAIN_FINANCIAL_FREEDOM_STRINGS.title,
    description: ATTAIN_FINANCIAL_FREEDOM_STRINGS.description,
    actionStickerCards: [
      getStickerCard('extra_cash'),
      getStickerCard('lower_cost_of_college'),
      getStickerCard('build_credit'),
      getStickerCard('savings_and_investing'),
    ],
  };
};

export const BE_WELL_SECTION = ({ navigate }: HomePageSection): ActionStickerCardSection => {
  const { getStickerCard } = useToolCardById({ navigate });

  return {
    title: BE_WELL_STRINGS.title,
    description: BE_WELL_STRINGS.description,
    actionStickerCards: [
      getStickerCard('navigating_stress'),
      getStickerCard('sleep_restoration'),
      getStickerCard('family_dynamics'),
      getStickerCard('healthcare'),
    ],
  };
};

export const MASTER_MINDSETS_SECTION = ({
  navigate,
}: HomePageSection): ActionStickerCardSection => {
  const { getStickerCard } = useToolCardById({ navigate });

  return {
    title: MASTER_MINDSETS_STRINGS.title,
    description: MASTER_MINDSETS_STRINGS.description,
    actionStickerCards: [
      getStickerCard('agency'),
      getStickerCard('learn_to_learn'),
      getStickerCard('growth_mindset'),
      getStickerCard('problem_solving'),
    ],
  };
};
